import { defineStore } from "pinia";
import { MasterLayoutState } from "@/types";

export const useMasterLayoutStore = defineStore("masterLayout", {
  state: (): MasterLayoutState => ({
    mobile: window.innerWidth < 1199,
    open: false,
    spinnerOn: false,
  }),

  actions: {
    toggleOpen() {
      this.open = !this.open;
    },

    toggleSpinner() {
      this.spinnerOn = !this.spinnerOn;
    },
  },
});
